export default __webpack_public_path__ + "static/media/W_C_False.b20cf3f8.jpg";